module.exports = __webpack_public_path__ + "arrow-next@2x.jpg?06a72ecab4a57e8938a786c65e9a8c9f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-next@2x.jpg
// module id = 155
// module chunks = 0